module.exports = __webpack_public_path__ + "img/head.91d57940.svg";